import React from 'react';
import { useLocation } from 'react-router-dom';
import { EAgentLandingPageType } from 'types/agent-landing-page';

import AgentLandingHeader from 'components/AgentLanding/AgentLandingHeader/AgentLandingHeader';
import { normalizeAgents } from 'components/AgentLanding/AgentLandingPrimitives';
import BiographyModal from 'components/AgentLanding/Biography/BiographyModal';
import ContactModal from 'components/AgentLanding/Contact/ContactModal';

const AgentLandingNavbar = ({
  agentLandingPageType, agentLandingPageToken, agentData, openAssessmentModal,
}) => {
  const location = useLocation();
  const [contactOpen, setContactOpen] = React.useState(false);
  const [bioOpen, setBioOpen] = React.useState(false);
  if (!agentData) return null;

  const agents = normalizeAgents(agentData);
  const logoUrl = agentData.teamLogoUrl || agentData.companyLogoUrl;
  let cta;
  if (agentLandingPageType === EAgentLandingPageType.ComparableProperties) {
    cta = {
      label: 'Discuss my report',
      accessibleLabel: `Discuss my property report with my ${agents.length > 1 ? 'advisors' : 'advisor'}`,
      onClick: openAssessmentModal,
      variant: 'outline',
    };
  } else if (agentLandingPageType === EAgentLandingPageType.DigitalAd) {
    cta = {
      label: 'Ask a question',
      accessibleLabel: `Ask ${agents.length > 1 ? 'us' : 'me'} a question`,
      onClick: () => setContactOpen(true),
      variant: 'outline',
    };
  } else if (agents[0]?.phoneNumber) {
    cta = {
      label: 'Call now',
      accessibleLabel: `Call ${agents[0].firstName}`,
      href: `tel:${agents[0].phoneNumber}`,
      variant: 'outline',
    };
  }

  return (
    <>
      {contactOpen && (
        <ContactModal
          onClose={() => setContactOpen(false)}
          agentLandingPageToken={agentLandingPageToken}
          agentData={agentData}
        />
      )}
      <BiographyModal
        open={bioOpen}
        onClose={() => setBioOpen(false)}
        agentData={agentData}
      />
      <AgentLandingHeader
        agents={agents}
        logoUrl={logoUrl}
        cta={cta}
        search={location.search}
        onBioClick={() => setBioOpen(true)}
      />
    </>
  );
};

export default AgentLandingNavbar;
